export const FETCH_PROGRAM_DISCOUNT_DATA_REQUEST = 'FETCH_PROGRAM_DISCOUNT_DATA_REQUEST';
export const FETCH_PROGRAM_DISCOUNT_DATA_SUCCESS = 'FETCH_PROGRAM_DISCOUNT_DATA_SUCCESS';
export const FETCH_PROGRAM_DISCOUNT_DATA_FAILURE = 'FETCH_PROGRAM_DISCOUNT_DATA_FAILURE';

export const CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_REQUEST = 'CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_REQUEST';
export const CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_SUCCESS = 'CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_SUCCESS';
export const CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_FAILURE = 'CREATE_PROGRAM_DISCOUNT_TRANSFER_DATA_FAILURE';

export const CREATE_USER_FORM_PROGRAM_DISCOUNT = 'CREATE_USER_FORM_PROGRAM_DISCOUNT';

export const PROGRAM_DISCOUNT_USERFORM_RESET = 'PROGRAM_DISCOUNT_USERFORM_RESET';